import * as React from 'react';
import isFunction from 'lodash/isFunction';
import get from 'lodash/get';
import ColumnGroup from '../ColumnGroup';
import HeaderCell from '../HeaderCell';
import isNullOrUndefined from './isNullOrUndefined';
function cloneCell(Cell, props) {
    return React.cloneElement(Cell, props);
}
function mergeCells(cells) {
    const nextCells = [];
    for (let i = 0; i < cells.length; i += 1) {
        const { width, colSpan, groupCount, groupHeader, isHeaderCell, headerHeight, verticalAlign, } = cells[i].props;
        const groupChildren = [];
        // fix(ColumnGroup): fix column cannot be sorted in ColumnGroup
        /**
         * 为列头添加分组
         */
        if (groupCount && isHeaderCell) {
            let nextWidth = width;
            let left = 0;
            for (let j = 0; j < groupCount; j += 1) {
                const nextCell = cells[i + j];
                const { width: nextCellWidth, sortable, children, dataKey, onSortColumn, sortColumn, sortType, } = nextCell.props;
                if (j !== 0) {
                    nextWidth += nextCellWidth;
                    left += cells[i + j - 1].props.width;
                    cells[i + j] = cloneCell(nextCell, { hidden: true });
                }
                groupChildren.push(React.createElement(HeaderCell, { key: j, left: left, dataKey: dataKey, width: nextCellWidth, sortable: sortable, sortColumn: sortColumn, sortType: sortType, onSortColumn: onSortColumn }, children));
            }
            nextCells.push(cloneCell(cells[i], {
                width: nextWidth,
                children: (React.createElement(ColumnGroup, { width: nextWidth, headerHeight: headerHeight, header: groupHeader, verticalAlign: verticalAlign }, groupChildren)),
            }));
            continue;
        }
        else if (colSpan) {
            /**
             * 如果存在 colSpan 属性，就去找它的下一个 Cell,
             * 看看值是否是 isNullOrUndefined，，如果为空这可以合并这个单元格
             */
            let nextWidth = width;
            for (let j = 0; j < colSpan; j += 1) {
                const nextCell = cells[i + j];
                if (nextCell) {
                    const { rowData, rowIndex, children, width: colSpanWidth, isHeaderCell, dataKey, } = nextCell.props;
                    const cellText = isFunction(children)
                        ? children(rowData, rowIndex)
                        : get(rowData, dataKey);
                    if ((rowData && isNullOrUndefined(cellText)) ||
                        (isHeaderCell && isNullOrUndefined(children))) {
                        nextWidth += colSpanWidth;
                        cells[i + j] = cloneCell(nextCell, {
                            hidden: true,
                        });
                    }
                }
            }
            nextCells.push(cloneCell(cells[i], {
                width: nextWidth,
                //  Fix this use of the variablecolSpan always evaluates to true
                'aria-colspan': nextWidth > width ? colSpan : undefined,
            }));
            continue;
        }
        nextCells.push(cells[i]);
    }
    return nextCells;
}
export default mergeCells;
